/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-notification-area[_ngcontent-%COMP%]{display:flex;flex-direction:row}.error-notification-area[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-right:16px;flex-grow:1}.error-notification-area[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center}\n/*# sourceMappingURL=notification.component.css.map*/"];
export { styles as styles };
